////////////////////
/* Parameter ID  */

////////////////////
export const ISOEntity = 1;
export const ISORegulator = 2;
export const ISOCompanyStructure = 3;
export const ISOProductSector1 = 4;
export const ISOProductSector2 = 5;
export const ISOProductSector3 = 6;
export const ISOProductSector4 = 7;
export const ISOProductSector5 = 8;
export const ISOClientType = 9;
export const ISOCountryCode3 = 10;
export const ISOCountryRegion = 11;
export const ISOCountryName = 12;
export const ISOExchangeType = 13;
export const ISOFeeType = 14;
export const ISOCountryCode = 15;
export const ISOValueType = 16;
export const ISOInternalFeeType = 17;
export const ISOCurrencyCode = 18;
export const ISOClientsType = 19;
export const ISOCommissionType = 20;
export const ISOProductType = 21;
export const ISOProductSubtypeType = 22;
export const ISOCashType = 22;
export const ISOTradeStatus = 23;
export const ISOBuySell = 24;
export const ISOPset = 25;
export const ISOTrader = 39;
export const ISOInternalFeeTypeSecondParam = 37;
export const ISOStrategy = 40;
export const ISOFuturesContract = 41;
export const ISOInternalFeeTypeThirdParam = 43;
export const ISOOPtionType = 53;

////////////////////
/* HTTP CONFIG   */
////////////////////
export const TIMEOUT = 500000;
export const TIMEOUT_REPORT = 500000;
export const TOKEN_HEADER = 'Bearer ';

////////////////////
/* PATHS          */
////////////////////
export const AUTH_LOGIN = '/api/auth/login';
export const AUTH_TOKEN_VERIFY = '/api/auth/verify-token';
export const AUTH_TOKEN_REFRESH = '/api/auth/refresh-token';

////////////////////
/* CONSTS         */
////////////////////

export const INTERNAL_PORTAL = 1;
export const EXTERNAL_PORTAL = 2;
export const TRADE_ENTRY = 351;
export const TRADE_AMENDMENT = 352;
export const TRADE_CANCEL = 353;

export const EQUITY_PRODUCT_TYPE = 334;
export const EQUITY_CFD_PRODUCT_TYPE = 335;
export const FIXED_INCOME_PRODUCT_TYPE = 336;
export const CASH_PRODUCT_TYPE = 337;
export const OPTION_PRODUCT_TYPE = 338;
export const FUTURE_PRODUCT_TYPE = 339;
export const COUPON_PAYMENT = 406;
export const CALCULATED_FEE = 732;
export const CASH_DIVIDEND = 359;
export const INDEX_PRODUCT_TYPE = 496;

export const STRUCTURED_PRODUCT_TYPE = 1725;

export const BUY = 354;
export const SELL = 355;
export const SSELL = 356;
export const BCOV = 357;
export const SSBUY = 808;
export const SSSELL = 809;

export const BPS_COMM = 250;
export const MILLION_COMM = 251;
export const ABSOLUTE_COMM = 252;
export const CPS_COMM = 253;
export const PCT_COMM = 731;
export const WITHHOLDING_TAX = 755;
export const PER_LOT_COMM = 652;
